import { Job } from "../types/Job";
import { generateUUID } from "@domain/uuid";

/**
 * Construct a fresh Job populated with import-friendly defaults.
 *
 * The class method `Job.defaultForImport(...)` is a pass-through to this
 * function; consumers can call either form.
 */
export function defaultJobForImport(
	fieldName?: string,
	depth?: number,
	density?: number,
	growerName?: string,
	frequencyOfMicros?: number,
	testPackage?: string,
	farmName?: string,
	labName?: string,
): Job {
	const defaults = {
		id: generateUUID(),
		name: "",
		fieldName: fieldName ?? "",
		importFieldName: fieldName ?? "",
		growerName: growerName ?? "",
		importGrowerName: growerName ?? "",
		depth: depth ?? 0,
		importDepth: depth ?? 0,
		farmName: farmName ?? "",
		importFarmName: farmName ?? "",
		labName: labName ?? "",
		importLabName: labName ?? "",
		frequencyOfMicros: frequencyOfMicros ?? undefined,
		externalFrequencyOfMicros: frequencyOfMicros ?? undefined,
		testPackage: testPackage ?? "",
		externalTestPackageId: testPackage ?? "",
		branchIds: [],
		regionIds: [],
		boundaryChangeType: undefined,
		boundaryChangeNotes: undefined,
		dealIds: [],
		externalId: "",
		fieldId: "",
		fieldPriority: "Regular Turn (default)",
		density: density ?? 0,
		importDensity: density ?? 0,
		growerPhoneNumber: "",
		jobFlags: [],
		dataSent: [],
		csvSentToLab: false,
		labSubmissionCode: "",
		isPointsAttached: false,
		isReadyToSample: false,
		labInstructions: "",
		submitterEmail: "",
		submitterName: "",
		eventId: "",
		growerIds: [],
		salespersonIds: [],
		edits: "",
		season: "",
		sampleChanges: "",
		url: "",
		labSubmittalId: "",
		companyName: "",
		boundaryAcres: 0,
		status: "Pending",
		statusNumber: 0,
		isBillingApproved: false,
		isBoundaryApproved: false,
		isBoundaryChanged: false,
		isMarkedReady: false,
		isPointsChanged: false,
		isTestJob: false,
		dateCreated: new Date(),
		lastCrop: undefined,
		nextCrop: undefined,
		yieldGoal: "",
		numberOfSamples: undefined,
		errorNotes: [],
		attachments: {
			pointsSHP: [],
			boundarySHP: [],
			boundaryGeoJSON: [],
			zonesSHP: [],
			executedPointsSHP: [],
			executedBoundarySHP: [],
			executedPointsBoundarySHP: [],
			labPDF: [],
			labCSV: [],
			labResults: [],
			fieldNotes: [],
		},
		files: {
			pointsSHP: undefined,
			pointsGeoJSON: undefined,
			boundarySHP: undefined,
			boundaryGeoJSON: undefined,
			zonesSHP: undefined,
			zonesGeoJSON: undefined,
			executedPointsSHP: undefined,
			executedBoundarySHP: undefined,
			executedPointsBoundarySHP: undefined,
			labPDF: undefined,
			labCSV: undefined,
			labResults: undefined,
			fieldNotes: undefined,
		},
	};
	return Object.assign(new Job(), defaults);
}
